import { currencyColumn, dateColumn, numberColumn, polymorphicColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { ownerEndpoints } from "@utils/morphTypes";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'property';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    primaryRelationshipColumn({column: 'id', endpoint, label: 'Address', include: 'owner', required: true}),
    dateColumn({column: 'sale_date', required: true}),
    currencyColumn({required: true}),
    polymorphicColumn({
        label: 'Previous Owner',
        column: 'owner_id',
        typeColumn: 'owner_type',
        relationship: 'owner',
        endpoints: ownerEndpoints,
    }),
    polymorphicColumn({
        label: 'New Owner',
        column: 'new_owner_id',
        typeColumn: 'new_owner_type',
        relationship: 'new_owner',
        endpoints: ownerEndpoints,
    }),
];


const PropertySales = forwardRef(function PropertySales(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {PropertySales};
